export const phoneRegex = /^[0-9]{10}$/

export const validatePhone = (phone: string) => {
  if (!phone.length) return false
  return phoneRegex.test(phone)
}